import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex/store'
import isMobile from 'ismobilejs'

import tokenApi from '@/api/token'

import Timetable from '@/components/timetable/Timetable'
import Login from '@/components/Login'
import ReservationListPage from '@/components/ReservationListPage/ReservationListPage'
import ReservationList from '@/components/ReservationListPage/ReservationList'
import MainPage from '@/components/MainPage'
import UserInfoPage from '@/components/UserInfo/UserInfoPage'
import ManagementPage from '@/components/ManagementPage/ManagementPage'
import UserList from '@/components/ManagementPage/UserList'
import UserRegistrationForm from '@/components/ManagementPage/UserRegistrationForm'
import ReschedulingList from '@/components/ManagementPage/ReschedulingList'
import HelpPage from '@/components/HelpPage/SimpleHelpPage'
import UserPage from '@/components/ManagementPage/UserPage'
import EditLecturePage from '@/components/ManagementPage/EditLecturePage'
import EditClassroomPage from '@/components/ManagementPage/EditClassroomPage'
import EditInformationPage from '@/components/ManagementPage/EditInformationPage'
import InformationNotification from '@/components/ManagementPage/InformationNotification'
import Logout from '@/components/Logout'
import ReschedulingSenderPage from '@/components/ReschedulingPage/ReschedulingSenderPage'
import ReschedulingSenderForm from '@/components/ReschedulingPage/ReschedulingSenderForm'
import ReschedulingSenderConfirmation from '@/components/ReschedulingPage/ReschedulingSenderConfirmation'
import ReschedulingSenderCompletion from '@/components/ReschedulingPage/ReschedulingSenderCompletion'
import ReschedulingReceiverPage from '@/components/ReschedulingPage/ReschedulingReceiverPage'
import ReschedulingReceiverForm from '@/components/ReschedulingPage/ReschedulingReceiverForm'
import ReschedulingReceiverConfirmation from '@/components/ReschedulingPage/ReschedulingReceiverConfirmation'
// import ReschedulingReceiverTest from '@/components/ReschedulingPage/ReschedulingReceiverTest'
import ReschedulingReceiverCompletion from '@/components/ReschedulingPage/ReschedulingReceiverCompletion'
import ReschedulingReceiverClassroom from '@/components/ReschedulingPage/ReschedulingReceiverClassroom'
import ReschedulingListPage from '@/components/ReschedulingPage/ReschedulingListPage'
// mobile
import SpMainPage from '@/components/Mobile/SpMainPage'
import SpTimetable from '@/components/Mobile/timetable/SpTable'
import Spuser from '@/components/Mobile/UserInfo/SpUserInfo'
import Spchangeuser from '@/components/Mobile/UserInfo/Spchangeuserinfo'
import SpSenderForm from '@/components/Mobile/ReschedulingPage/SpSenderForm'
import SpSenderConfirmation from '@/components/Mobile/ReschedulingPage/SpSenderConfirmation'
import SpSenderCompletion from '@/components/Mobile/ReschedulingPage/SpSenderCompletion'
import SpReceiverPage from '@/components/Mobile/ReschedulingPage/SpReceiverPage'
import SpReceiverClassroom from '@/components/Mobile/ReschedulingPage/SpReceiverClassroom'
import Spconfirmation from '@/components/Mobile/ReschedulingPage/Spconfirmation_rcvr'
import SpReceiverCompletion from '@/components/Mobile/ReschedulingPage/SpReceiverCompletion'
import SpReschedulingList from '@/components/Mobile/ReschedulingPage/SpreschedulingList'
import SpHelpPage from '@/components/Mobile/HelpPage/SpHelpPage'
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/table',
      name: 'MainPage',
      component: MainPage,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'table',
          name: 'Timetable',
          component: Timetable,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: 'reservation_list',
          name: 'ReservationListPage',
          component: ReservationListPage,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: 'reservationlist',
          name: 'ReservationList',
          component: ReservationList,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: 'help',
          name: 'HelpPage',
          component: HelpPage,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: 'userinfo',
          name: 'UserInfo',
          component: UserInfoPage,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: 'management',
          name: 'ManagementPage',
          component: ManagementPage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'users',
              name: 'UserList',
              component: UserList,
              meta: {requiresAuth: true}
            },
            {
              path: 'user_registration',
              name: 'UserRegistrationForm',
              component: UserRegistrationForm,
              meta: {requiresAuth: true}
            },
            {
              path: 'lecture_registration',
              name: 'EditLecturePage',
              component: EditLecturePage,
              meta: {requiresAuth: true}
            },
            {
              path: 'classroom_registration',
              name: 'EditClassroomPage',
              component: EditClassroomPage,
              meta: {requiresAuth: true}
            },
            {
              path: 'information',
              name: 'EditInformationPage',
              component: EditInformationPage,
              meta: {requiresAuth: true}
            },
            {
              path: 'reschedulings',
              name: 'ReschedulingList',
              component: ReschedulingList,
              meta: {requiresAuth: true}
            },
            {
              path: 'InformationNotification',
              name: 'InformationNotification',
              component: InformationNotification,
              meta: {requiresAuth: true}
            }
          ]
        },
        {
          path: 'management/user/:id',
          name: 'UserPage',
          component: UserPage,
          meta: { requiresAuth: true }
        },
        {
          path: 'management/lecture_edit',
          name: 'EditLecturePage',
          component: EditLecturePage,
          meta: { requiresAuth: true }
        },
        {
          path: 'management/classroom_edit',
          name: 'EditClassroomPage',
          component: EditClassroomPage,
          meta: { requiresAuth: true }
        },
        {
          path: '/rescheduling',
          name: 'ReschedulingSenderPage',
          component: ReschedulingSenderPage,
          meta: { requiresAuth: true },
          children: [
            {
              path: '',
              name: 'ReschedulingSenderForm',
              component: ReschedulingSenderForm,
              meta: { requiresAuth: true }
            },
            {
              path: 'confirmation',
              name: 'ReschedulingSenderConfirmation',
              component: ReschedulingSenderConfirmation,
              meta: { requiresAuth: true }
            },
            {
              path: 'completion',
              name: 'ReschedulingSenderCompletion',
              component: ReschedulingSenderCompletion,
              meta: { requiresAuth: true }
            }

          ]
        },
        {
          path: '/rescheduling/:rescheduling_hash',
          name: 'ReschedulingReceiverPage',
          component: ReschedulingReceiverPage,
          meta: {requiresAuth: true},
          children: [
            {
              path: '',
              name: 'ReschedulingReceiverForm',
              component: ReschedulingReceiverForm,
              meta: { requiresAuth: true }
            },
            {
              path: 'confirmation_rcvr',
              name: 'ReschedulingReceiverConfirmation',
              component: ReschedulingReceiverConfirmation,
              meta: { requiresAuth: true }
            },
            {
              path: 'ReschedulingReceiverClassroom',
              name: 'ReschedulingReceiverClassroom',
              component: ReschedulingReceiverClassroom,
              meta: { requiresAuth: true }
            },
            {
              path: 'final_confirmation',
              name: 'ReschedulingReceiverCompletion',
              component: ReschedulingReceiverCompletion,
              meta: { requiresAuth: true }
            }
          ]
        }
      ]
    },
    {
      path: '/SpTop',
      name: 'SpMainPage',
      redirect: '/Sptable',
      component: SpMainPage,
      children: [
        {
          path: '/SpTable',
          name: 'SpTimeTable',
          component: SpTimetable,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: '/Spuser',
          name: 'Spuser',
          component: Spuser,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: '/Spchangeuser',
          name: 'Spchangeuser',
          component: Spchangeuser,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: '/SpRescheduling',
          name: 'SpRescheduling',
          component: SpSenderForm,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: '/SpSenderConfirmation',
          name: 'SpSenderConfirmation',
          component: SpSenderConfirmation,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: '/SpSenderCompletion',
          name: 'SpSenderCompletion',
          component: SpSenderCompletion,
          // メタフィールド
          meta: { requiresAuth: true }
        },
        {
          path: '/SpRescheduling/:rescheduling_hash',
          name: 'SpReceiverPage',
          component: SpReceiverPage,
          meta: {requiresAuth: true}
        },
        {
          path: '/SpRescheduling/:rescheduling_hash/SpReceiverClassroom',
          name: 'SpReceiverClassroom',
          component: SpReceiverClassroom,
          meta: { requiresAuth: true }
        },
        {
          path: '/SpRescheduling/:rescheduling_hash/Spconfirmation_rcvr',
          name: 'Spconfirmation_rcvr',
          component: Spconfirmation,
          meta: { requiresAuth: true }
        },
        {
          path: '/SpRescheduling/:rescheduling_hash/SpReceiverCompletion',
          name: 'SpReceiverCompletion',
          component: SpReceiverCompletion,
          meta: { requiresAuth: true }
        },
        {
          path: '/SpReschedulingList',
          name: 'SpReschedulingList',
          component: SpReschedulingList,
          meta: { requiresAuth: true }
        },
        {
          path: '/SpHelpPage',
          name: 'SpHelpPage',
          component: SpHelpPage,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/reschedulinglist',
      name: 'ReschedulingListPage',
      component: ReschedulingListPage,
      meta: { requiresAuth: true }
    }
  ],
  linkActiveClass: 'currentLink',
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 48 }
        // , offset: { x: 0, y: 10 }
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      tokenApi.getValidity()
      .then((res) => {
        if (!res.data.is_valid) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        } else {
          let checkPath = () => {
            let isSmartPhone = isMobile.phone
            if (isSmartPhone) {
              if (!to.path.match(/Sp/)) {
                // スマホで観覧なのにスマホページじゃないときの処理
                next({
                  path: '/SpTop'
                })
              }
            }
            if (to.path.includes('/management') && !store.state.userInfo.user_type === 'admin') {
              next({
                path: '/'
              })
            } else if ((to.path === '/rescheduling/confirmation' && from.path !== '/rescheduling' && from.path !== '/rescheduling/') ||
                        (to.path === '/rescheduling/complition' && from.path !== '/rescheduling/confirmation' && from.path !== '/rescheduling/confirmation/')) {
              next({
                path: '/rescheduling'
              })
            } else {
              next()
            }
          }
          if (!store.state.userInfo.hasOwnProperty('user_id')) {
            store.dispatch('getUserInfo')
            .then(checkPath)
          } else {
            checkPath()
          }
        }
      })
    }
  } else {
    next() // next() を常に呼び出すようにしてください!
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js